// export layout related constants
export const LAYOUT_VERTICAL = 'vertical';

export const LAYOUT_HORIZONTAL = 'horizontal';

export const LAYOUT_MODE = localStorage.getItem('changeMode') || 'light';

export const LAYOUT_WIDTH = 'fluid';

export const LAYOUT_POSITION = 'fixed';

export const TOPBAR = localStorage.getItem('changeMode') || 'light';

export const SIDEBAR_SIZE = 'default';

export const SIDEBAR_COLOR = localStorage.getItem('changeMode') || 'light';

